import ImageEditor from './components/ImageEditor.vue';


export function useDamImageEditor(store, bodytextEditor, newspaper_id = 0) {
    let imageEditorData = {
        mode: null,
        media: null,
        index: null
    };

    function closeEditor() {
        imageEditorData.media = null;
        imageEditorData.mode = null;
        imageEditorData.index = null;
    }

    function openEditor(media, mode, imgToEdit) {
        imageEditorData.mode = mode;

        console.log("Media edit", media);
        if (mode == 'inline') {
            let src = media.getAttribute("src");
            if (src /* && src.startsWith("/published-images/")*/) {
                imgToEdit.value = src;
                imageEditorData.media = media;
            } else {
                console.log("Immagine remota inline non supportata", media);
            }
        } else if (mode == 'attachment') {
            if (media?.type == 'remote') {
                // From remote
                console.warn("Immagine remota allegata non supportata", media);
                imgToEdit.value = media.publicUrl + media.url;
                imageEditorData.media = media;
                imageEditorData.index = store.draftDetailImages.images.indexOf(media);
            } else if (media.orig) {
                // From PC
                imgToEdit.value = media.url;
                imageEditorData.media = media;
                imageEditorData.index = store.draftDetailImages.images.indexOf(media);
            } else if (media.path) {
                // From draft
                if (store.$id == 'published-state') {
                    imgToEdit.value = "/published-images/" + media.path;
                } else if(store.$id == 'draft-state') {
                    imgToEdit.value = "/draft-images/" + media.path;
                } else {
                    throw new Error("Store not supported: " + store.$id);
                }
                imageEditorData.media = media;
                imageEditorData.index = store.draftDetailImages.images.indexOf(media);
            }
        } else {
            throw new Error("Modalità non supportata: " + mode);
        }
    }

    function saveImage(file) {
        return new Promise( (resolve, reject) => {
            if (imageEditorData.mode == 'inline') {
                let url = new URL(imageEditorData.media.getAttribute("src"), window.document.location.origin);
                let params = url.searchParams;
                const fileName = url.pathname.split('\\').pop().split('/').pop();
                const myNewFile = new File([file], decodeURI(fileName), { type: file.type });
                if(store.$id == 'published-state') {
                    store.uploadImage(myNewFile, newspaper_id, true).then((response) => {
                        let ckver = Number.parseInt(params.get("ckver"));
                        if (isNaN(ckver)) {
                            ckver = 1;
                        }
                        bodytextEditor.value.instance.execute('replaceImageSource', { source: response.default + "?ckver=" + (ckver + 1) })
                        imageEditorData.media = null;
                        imageEditorData.mode = null;
                        resolve();
                    })
                } else if(store.$id == 'draft-state') {
                    store.uploadImage(myNewFile, true).then( (response) => {
                        let ckver = Number.parseInt(params.get("ckver"));
                        if(isNaN(ckver)) {
                            ckver = 1;
                        }
                        bodytextEditor.value.instance.execute( 'replaceImageSource', { source: response.default + "?ckver=" + (ckver+1) } )
                        imageEditorData.media = null;
                        imageEditorData.mode = null;
                        resolve();
                    })
                }
            } else if (imageEditorData.mode == 'attachment') {
                if (imageEditorData.media?.type == 'remote') {
                    const fileName = imageEditorData.media.file_name;
                    const myNewFile = new File([file], decodeURI(fileName), { type: file.type });
                    imageEditorData.media.url = URL.createObjectURL(myNewFile);
                    imageEditorData.media.orig = myNewFile;
                    delete imageEditorData.media.type;
                    delete imageEditorData.media.remote_id;
                    resolve();
                }  else if(store.$id == 'draft-state' && imageEditorData.media.path) {
                    let url = new URL('/draft-images/' + imageEditorData.media.path, window.document.location.origin);
                    const fileName = url.pathname.split('\\').pop().split('/').pop();
                    let params = url.searchParams;
                    let myNewFile = new File([file], decodeURI(fileName));
                    store.uploadImage(myNewFile, true).then( (response) => {
                        let ckver = Number.parseInt(params.get("ckver"));
                        if(isNaN(ckver)) {
                            ckver = 1;
                        }
                        imageEditorData.media.path = response.default.replace('/draft-images/', '') + "?ckver=" + (ckver+1)
                        imageEditorData.media = null;
                        imageEditorData.mode = null;
                        resolve();
                    })
                } else {
                    const fileName = imageEditorData.media.orig.name;
                    let myNewFile = new File([file], decodeURI(fileName), { type: file.type });
                    imageEditorData.media.url = URL.createObjectURL(myNewFile);
                    imageEditorData.media.orig = myNewFile;
                    resolve();
                }
            } else {
                console.warn("Save image editor mode not supported:", imageEditorDatas.mode);
                resolve();
            }
        })

    }
    return { openEditor, saveImage, closeEditor };
}

export default ImageEditor;